<template>
  <div class="fragment">

    <template v-if="$store.getters.getNewPayments.length > 0 && $store.getters.getNewPaymentsLoading !== true">
      <div class="site-table-wrap small-table"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
            'payments_ID',
            'payments_Created',
            'common_user',
            'payments_comment',
            'payments_Total',
            'payments_Status',
            ])"></div>

        <table class="site-table" v-if="!isMobileFunc()">
          <thead>
          <tr>
            <th></th>
            <th> {{$t('payments_ID.localization_value.value')}}</th>
            <th> {{$t('payments_Created.localization_value.value')}}</th>
            <th> {{$t('common_user.localization_value.value')}}</th>
            <th> {{$t('payments_comment.localization_value.value')}}</th>
            <th> {{$t('payments_Total.localization_value.value')}},$</th>
            <th> {{$t('payments_Status.localization_value.value')}}</th>
            <th width="100%"></th>
            <th></th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(item, index) in $store.getters.getNewPayments" :key="index">
            <td>
              <DefaultCheckbox
                      class="empty-label"
                      :dataValue="item.id"
                      v-if="item.status !== PAYMENTS_STATUSES.SUCCESS_TRANSACTION_STATUS"
              />
            </td>
            <td>
              <span class="table-link btn-style"
                    @click="showInfoPopup(item.id)"
              >
                #{{item.id}}
              </span>
            </td>
            <td>
              {{ item.created_at | moment("DD MMM, YYYY") }}
            </td>
            <td>
              <TableUserColumn
                      :item="item"
              />
            </td>
            <td>
              <div class="table-row payment-comment">
                <TooltipTextHelper
                        v-if="item.payment_transaction_detail"
                        :text="item.payment_transaction_detail.description"
                        :paragraph="item.payment_transaction_detail.description"
                        :fullTextWidth="290"
                />
              </div>
            </td>
            <td>
              {{item.user_amount}}
            </td>
            <td>
              <div
                      v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate([
            'common_InProgress',
            'common_Paid',
            'common_Rejected',
            'common_statusNew',
            ])"></div>
                <div class="table-row"
                     v-if="item.status === PAYMENTS_STATUSES.IN_PROGRESS_TRANSACTION_STATUS">
                  <StatusIcoBtn :type="'dots'" class="mr-2 t-0"/>
                  {{$t('common_InProgress.localization_value.value')}}
                </div>
                <div class="table-row"
                     v-if="item.status === PAYMENTS_STATUSES.SUCCESS_TRANSACTION_STATUS">
                  <StatusIcoBtn :type="'active'" class="mr-2 t-0"/>
                  {{$t('common_Paid.localization_value.value')}}
                </div>
                <div class="table-row"
                     v-if="item.status === PAYMENTS_STATUSES.CANCELED_TRANSACTION_STATUS ||
                          item.status === PAYMENTS_STATUSES.ERROR_STATUS">
                  <StatusIcoBtn :type="'rejected'" class="mr-2 t-0"/>
                  {{$t('common_Rejected.localization_value.value')}}
                </div>
                <div class="table-row"
                     v-if="item.status === PAYMENTS_STATUSES.ON_HOLD_STATUS">
                  <StatusIcoBtn :type="'star'" class="mr-2 t-0"/>
                  {{$t('common_statusNew.localization_value.value')}}
                </div>
              </div>
            </td>
            <td width="100%">

            </td>
            <td align="right">
              <div
                      v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate([
            'common_Pay',
            'common_edit',
            'common_delete',
            ])"></div>
                <div class="table-right table-manage-list table-manage-list--small"
                     >

                  <ManagerButton @reloadManagerBtn="$store.commit('setGlobalUpdateManagerButton', Math.random()) " :key="$store.getters.getGlobalUpdateManagerButton"
                          class="right"
                  >
                    <template v-if="item.status !== PAYMENTS_STATUSES.SUCCESS_TRANSACTION_STATUS" slot="item">
                      <LinkButton
                              :value="$t('common_Pay.localization_value.value')"
                              :type="'dollar'"
                              @click.native="payPaymentHandle(item.id, {goToTable: false})"
                      />
                    </template>
                    <template slot="item">
                      <LinkButton
                              :value="$t('common_edit.localization_value.value')"
                              :type="'edit'"
                              :link="$store.getters.GET_PATHS.financeNewPayment + '/edit/' + item.id"
                      />
                    </template>
                    <template v-if="item.status !== PAYMENTS_STATUSES.SUCCESS_TRANSACTION_STATUS" slot="item">
                      <LinkButton
                              :value="$t('common_delete.localization_value.value')"
                              :type="'delete'"
                              @click.native="removePayment(item.id, index)"
                      />
                    </template>
                  </ManagerButton>
                </div>
              </div>
            </td>
          </tr>

          </tbody>
        </table>

        <div class="table-card" v-if="isMobileFunc()">
          <div class="table-card__list">
            <div class="table-card__item"
                 v-for="(item, index) in $store.getters.getNewPayments"
                 :key="index"
            >
              <NewPaymentsTableMobile
                      :item="item"
                      @removePayment="removePayment(item.id, index)"
                      @payPayment="payPaymentHandle(item.id,{goToTable: false})"
                      @changeSendEmailPopup="changeSendEmailPopup(true)"
                      @changeCommentsPopup="changeCommentsPopup(true)"
                      @changeLastFiveIPPopup="changeLastFiveIPPopup(true)"
              />
            </div>
          </div>
        </div>

        <div class="table-bottom-btn" >
          <div class="table-bottom-btn__inner">
            <ShowMore
                    v-if="$store.getters.getNewPaymentsCommonList.next_page_url !== null && $store.getters.getNewPayments.length > 0"
                    @click.native="$emit('showMore')"
                    v-bind:class="{'disabled-btn' : $store.getters.getNextNewPaymentsPage}"
                    :count="$store.getters.getNewPaymentsCommonList.total - $store.getters.getNewPaymentsForPage * $store.getters.getNewPaymentsCommonList.current_page < $store.getters.getNewPaymentsForPage ?
                  $store.getters.getNewPaymentsCommonList.total - $store.getters.getNewPaymentsForPage * $store.getters.getNewPaymentsCommonList.current_page:
                  $store.getters.getNewPaymentsForPage"
            />

            <ExportBtn
                @downloadFiles="type => $emit('downloadFiles', type)"
                    class="table-bottom-btn__right"/>
          </div>
        </div>
      </div>
    </template>

    <template v-if="$store.getters.getNewPaymentsLoading === false && $store.getters.getNewPayments.length === 0">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>

    <!--<ProductsToWarehouse @close="closePopup" v-if="isModalProductsToWarehouse"/>-->

    <InfoIDPopup
            v-if="isModalInfoIDPopup"
            @close="isModalInfoIDPopup = false"
            @reload="$emit('reload')"
    />

  </div>
</template>

<script>
  import ShowMore from "../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import LinkButton from "../../../../../../UI/buttons/LinkButton/LinkButton";
  import ManagerButton from "../../../../../../UI/buttons/ManagerButton/ManagerButton";
  import ExportBtn from '../../../../../../coreComponents/Buttons/Export/Export'
  import {mixinDetictingMobile} from '../../../../../../../mixins/mobileFunctions'
  import DefaultCheckbox from "../../../../../../UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
  import StatusIcoBtn from "../../../../../../UI/status/StatusIcoBtn/StatusIcoBtn";
  import NoResult from "../../../../../../coreComponents/NoResult/NoResult";
  import {CUSTOMERS_PAYMENTS_STATUSES} from "../../../../../../../staticData/staticVariables";
  import NewPaymentsTableMobile from "./NewPaymentsTableMobile/NewPaymentsTableMobile";
  import {newPaymentsMixin} from "../../../../../../../mixins/newPaymentsMixins/newPaymentsMixin";
  import InfoIDPopup from "../../../../popups/InfoIDPopup/InfoIDPopup";
  import TooltipTextHelper from "../../../../../../coreComponents/TooltipTextHelper/TooltipTextHelper";
  import TableUserColumn from "../../../../../../coreComponents/TableComponents/TableUserColumn/TableUserColumn";


  export default {
    name: "NewPaymentsTable",

    components: {
      TableUserColumn,
      TooltipTextHelper,
      InfoIDPopup,
      NewPaymentsTableMobile,
      NoResult,
      ShowMore,
      ExportBtn,
      LinkButton,
      ManagerButton,
      DefaultCheckbox,
      StatusIcoBtn,
    },

    mixins: [mixinDetictingMobile, newPaymentsMixin],

    props: {
      countFilterParams: Number,
    },

    data() {
      return {
        orderId: '',
        showFilter: false,
        isMobile: false,

        showContent: false,

        isModalInfoIDPopup: false,
        PAYMENTS_STATUSES: CUSTOMERS_PAYMENTS_STATUSES,

        show1: false,
        show2: false,

      }
    },

    methods: {
      closePopup(){
        // this.isModalProductsToWarehouse = false
      },

      showInfoPopup(id) {
        this.$store.dispatch('getNewPayments', id).then(() => {
          this.isModalInfoIDPopup = true
        })
      },

      removePayment(id, index){
        let text = {
          title: 'common_deleteConfirm',
          txt: '',
          yes: 'common_confirm',
          no: 'common_confirmNo'
        }

        let confirm = () => {

          this.$store.dispatch('deleteNewPayments', id).then((response) => {
            if (this._.has(response, 'data') && response.status === this.$store.getters.GET_ERRORS.SUCCESS_CODE) {

              let payments = this.$store.getters.getNewPayments
              payments.splice(index, 1)
              this.openNotify('success', 'common_notificationRecordDeleted')

            } else {
              setTimeout(() => {
                this.openNotify('error', 'common_notificationUndefinedError')
              }, 200)
            }
          })

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

      payPaymentHandle(id, {goToTable=false}){

        let text = {
          title: 'common_AreYouSure',
          txt: '',
          yes: 'common_confirm',
          no: 'common_confirmNo'
        }

        let confirm = () => {

          this.payPayment(id, {goToTable: goToTable})

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },
    }

  }

</script>

<style scoped lang="scss">
  /deep/ .payment-comment .tooltip-helper-full{
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 290px;
    position: relative;
    display: inline-block;
    white-space: nowrap;
  }

  .payment-comment{
    width: 300px;
  }

  .table-manage-list {
    width: 230px;

    .manager-btn {
      max-width: 230px;
    }
  }


  @media (max-width: 1900px){
    .comment-row{
      width: 200px;
    }
  }

  @media (max-width: 1400px){
    .comment-row{
      max-width: 150px;
    }

    .payment-comment,
    /deep/ .payment-comment .tooltip-helper-full{
      width: 150px;
    }
  }

  .site-table thead th:first-child,
  .site-table tbody td:first-child{
    padding-right: 0;
  }

  .site-table thead th:last-child,
  .site-table tbody td:last-child{
    padding-right: 0;
  }

  .small-table th,
  .small-table td{
    white-space: nowrap;
  }

</style>
